<template>
  <div>
    <v-card-actions>
      <v-card-title>IMAGES</v-card-title>
      <v-btn fab small color="primary" @click="imageAdd = true">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-card-actions>
    <project-image-view></project-image-view>
    <project-image-add
      :image-add="imageAdd"
      @update-add-image-modal="updateImageModal"
    ></project-image-add>
  </div>
</template>

<script>
import ProjectImageView from "@/components/Projects/ProjectInnerCardsComp/ProjectImageView";
import ProjectImageAdd from "@/components/Projects/ProjectInnerCardsComp/ProjectImageAdd";
export default {
  name: "ProjectImage",
  components: {
    "project-image-add": ProjectImageAdd,
    "project-image-view": ProjectImageView,
  },
  props: ["images"],
  data() {
    return {
      imageData: [],
      imageAdd: false,
    };
  },
  methods: {
    updateImageModal(value) {
      this.imageAdd = value;
    },
  },
};
</script>

<style scoped></style>
